import { toE164PhoneFormatter } from "../../helpers/AssetHelpers/AssetHelpers";
import { IClientData } from "../../models/ClientData";

/** GTM conversion event for a lander's first full lead. */
export function pushLanderFormSubmitEvent(payload: IClientData) {
  const phoneNumber = toE164PhoneFormatter(payload.primaryPhone ?? "");
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "lander_form_submit",
    user_details: payload,
    user_data: { email: payload.email, phone_number: phoneNumber },
    eventCallback: () => localStorage.removeItem("lander_ad_source"),
  });
}
